'use strict';

/**
 * @ngdoc function
 * @name thothApp.controller:EmployeePositionService
 * @description
 * # EmployeePositionCtrl
 * Controller of the thothApp
 */
angular.module('thothApp.services')
  .factory('EmployeePosition', ['$http', 'domain', 'BaseService', function ($http, domain, BaseService) {
    var BASE_EMPLOYEE_POSITION_URL = domain.name + '/api/v1/employee_positions/';
    var baseService = new BaseService();

    baseService.initialize({
      baseUrl: BASE_EMPLOYEE_POSITION_URL,
      baseModelName: 'employeePosition'
    });

    return baseService;
  }]);
